// Team-member dashboard API (admins view/manage anyone; a member views their own).
import { api } from './client.js';

export const fetchTeamMember = (userId) => api.get(`/team/${userId}`).then((r) => r.data);
export const updateMemberProfile = (userId, body) => api.put(`/team/${userId}/profile`, body).then((r) => r.data);
export const setMemberAssignments = (userId, companyIds) =>
  api.put(`/team/${userId}/assignments`, { companyIds }).then((r) => r.data);
